import {
  getAllRows,
  getRow,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";

const TABLA = "empresas";

export const getEmpresas = () => getAllRows(TABLA);

export const getEmpresaById = (id) => getRow(TABLA, id);

export const getEmpresasPropias = async () => {
  const empresas = await getAllRows(TABLA);
  return empresas.filter((e) => e.tipo === "propia");
};

export const getEmpresasProveedoras = async () => {
  const empresas = await getAllRows(TABLA);
  return empresas.filter((e) => e.tipo === "proveedor");
};

export const createEmpresa = ({ id, ...data }) => createRow(TABLA, id, data);

export const updateEmpresa = (id, data) => updateRow(TABLA, id, data);

export const deleteEmpresa = (id) => deleteRow(TABLA, id);
